import React from "react";
import contentfulSeriesFactory, { fetchProps } from "@insightfulscience/contentful/Apps/Series";
import PageMeta from "@insightfulscience/smart-react/PageMeta";
import { useLocale } from "@insightfulscience/smart-react/i18";
import SectionTryForFree from "../../SectionTryForFree";
import SiteLayout from "../../SiteLayout";
import AcademyToC from "../../AcademyToC";
import { contentfulProps } from "../../config";

const seriesLayout = ({ children }) => {
	const [t] = useLocale("series-page");
	return (
		<SiteLayout>
			<PageMeta>
				<PageMeta.Twitter image={t("META_TWITTER_IMAGE")} isImageBaseUrl />
			</PageMeta>
			{children}
			<SectionTryForFree />
		</SiteLayout>
	);
};

const ContentfulSeriesApp = contentfulSeriesFactory({
	Layout: seriesLayout,
	contentfulProps,
	pageProps: {
		brandCode: "gn",
		siteDomain: "https://www.geneious.com",
		showLogoAcademy: true,
		academyToCComponent: {
			Component: AcademyToC,
		},
		showToC: true,
	},
	mode: "isr",
});

export const getStaticPaths = async () => ({
	paths: [],
	fallback: "blocking",
});

export const getStaticProps = async ({ params: { slug } }) => {
	const props = await fetchProps(contentfulProps, slug, false);

	return props?.video
		? {
				props,
				revalidate: false,
		  }
		: { notFound: true };
};

export default ContentfulSeriesApp;
